import type { Href } from "expo-router";
import { useLocalSearchParams } from "expo-router";
import { useTenantActivation } from "@visioni/a3s-monitoring/app";
import { patriotToolsHref } from "../routes";
import { useActivationScopeOptions } from "../hooks/useActivationScopeOptions";
import { useDirectoryTenantName } from "../hooks/useDirectoryTenantName";
import { ActivationDetailView } from "../components/ActivationDetailView";
import { ActivationStatus } from "../components/ActivationStatus";
import { PatriotToolsPage } from "../components/PatriotToolsPage";
import { QueryNotice } from "../components/QueryNotice";
import { formatInstant, hasText } from "../format";

export function TenantActivationScreen() {
  const { tenantId, ticketNo = "" } = useLocalSearchParams<{ tenantId: string; ticketNo?: string }>();
  const { activation, isLoading, error, refetch } = useTenantActivation(ticketNo);
  const scope = useActivationScopeOptions();
  const tenantName = useDirectoryTenantName();

  return (
    <PatriotToolsPage
      title={`Activation ${ticketNo}`}
      {...(activation !== undefined && {
        subtitle: [activation.description, `created ${formatInstant(activation.createdDateTime)}`]
          .filter(hasText)
          .join(" · "),
        titleAccessory: <ActivationStatus activation={activation} />,
      })}
    >
      {activation === undefined ?
        <QueryNotice isLoading={isLoading} error={error} onRetry={refetch} />
      : <ActivationDetailView
          activation={activation}
          // The route serves only an activation whose marker names this tenant.
          tenant={{ label: tenantName(tenantId) ?? tenantId, href: patriotToolsHref(tenantId, "tenant-activations") }}
          siteLabel={scope.siteLabel}
          cameraLabel={scope.cameraLabel}
          cameraHref={(siteId, cameraKey) => `/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}` as Href}
          listHref={(filters) => patriotToolsHref(tenantId, "tenant-activations", filters)}
        />
      }
    </PatriotToolsPage>
  );
}
